export default __webpack_public_path__ + "static/media/Poppins-Italic.c81c1d62.woff";